




import {
  Vue,
  Watch,
  Component,
} from "@/shared/vuepack";
import { PartnerContentType } from "@/admin/types";
import { usePartnerContentStore } from "@/shared/store/partnerContent";

@Component({ components: {} })
export default class UserPartnerContent extends Vue {
  partnerContent = "";
  partnerContentStore = usePartnerContentStore();

  mounted () {
    this.partnerContentStore.getUserPartnerContent(PartnerContentType.DrivewealthInvestmentPromo);
    this.onPartnerContentLoaded();
  }

  @Watch("isLoading")
  onPartnerContentLoaded () {
    if (this.partnerContentStore.isLoadedUserContent) {
      this.partnerContent = this.partnerContentStore.userPartnerContent;
    }
  }

  get isLoading () {
    return this.partnerContentStore.isLoadingUserContent;
  }
}
